import Swiper from 'swiper';
import { Thumbs, Navigation, Pagination } from 'swiper/modules';
import { Fancybox } from '@fancyapps/ui';

class ProductMediaSwiper extends HTMLElement {
  connectedCallback() {
    this.initThumbSwiper();
    this.initSwiper();
    this.initFancybox();
  }

  initSwiper() {
    new Swiper('.swiper--media', {
      modules: [Thumbs, Navigation, Pagination],
      spaceBetween: 16,
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      pagination: {
        el: '.swiper-pagination',
        clickable: true,
      },
      thumbs: {
        swiper: this.thumbSwiper,
      },
    });
  }

  initThumbSwiper() {
    this.thumbSwiper = new Swiper('.swiper--thumbs', {
      spaceBetween: 8,
      slidesPerView: 'auto',
      watchSlidesProgress: true,
    });
  }

  initFancybox() {
    Fancybox.bind('[data-fancybox]', {
      Carousel: {
        Panzoom: {
          touch: (panzoom, event) => event?.target.nodeName !== 'MODEL-VIEWER',
        },
      },
    });
  }
}

customElements.define('product-media-swiper', ProductMediaSwiper);
